/**
 * Nombres de columna en Airtable = exactamente como en la UI de la base (sensible a mayúsculas).
 * Tipos deben coincidir con lo que espera la API (multi-select → array de strings en JSON).
 *
 * Opciones del campo Role (selección única): copiar desde `src/data/waitlistRoles.ts` → WAITLIST_ROLE_OPTIONS[].label
 */
export const AIRTABLE_WAITLIST_FIELD_IDS = {
  name: 'Name',
  email: 'Email',
  company: 'Company',
  role: 'Role',
  phone: 'Phone',
  companyType: 'Company Type',
  companySize: 'Company Size',
  headquarters: 'Headquarters',
  /** Texto largo: resumen de necesidad de ensayo (lo mismo que ves en el paso 3 del formulario). */
  trialNeeds: 'Trial Needs',
  trialPhases: 'Trial Phases',
  therapeuticAreas: 'Therapeutic Areas',
  targetCountries: 'Target Countries',
  expectedTrials: 'Expected Trials per Year',
  timeframe: 'Timeframe to Start',
  budgetRange: 'Budget Range',
  hearAboutUs: 'Lead Source',
  specificRequirements: 'Specific Requirements or Comments',
} as const satisfies Readonly<Record<string, string>>;

export type AirtableWaitlistFieldKey = keyof typeof AIRTABLE_WAITLIST_FIELD_IDS;

export const AIRTABLE_WAITLIST_FIELD_FORMATS: Record<
  AirtableWaitlistFieldKey,
  'single_line' | 'long_text' | 'multi_select'
> = {
  name: 'single_line',
  email: 'single_line',
  company: 'single_line',
  role: 'single_line',
  phone: 'single_line',
  companyType: 'single_line',
  companySize: 'single_line',
  headquarters: 'single_line',
  trialNeeds: 'long_text',
  trialPhases: 'multi_select',
  therapeuticAreas: 'multi_select',
  targetCountries: 'multi_select',
  expectedTrials: 'single_line',
  timeframe: 'single_line',
  budgetRange: 'single_line',
  hearAboutUs: 'single_line',
  specificRequirements: 'long_text',
};

export function getAirtableWaitlistConfig(): {
  token: string;
  baseId: string;
  tableId: string;
} | null {
  const token = process.env.REACT_APP_AIRTABLE_TOKEN?.trim();
  const baseId = process.env.REACT_APP_AIRTABLE_BASE_ID?.trim();
  const tableId =
    process.env.REACT_APP_AIRTABLE_TABLE_ID?.trim() ||
    process.env.REACT_APP_AIRTABLE_WAITLIST_TABLE_ID?.trim() ||
    'tblkeEAuyeeu9gXxN';

  if (!token || !baseId) {
    return null;
  }
  return { token, baseId, tableId };
}
